import store from 'utils/store/withMiddleware'
import getValidEndDate from 'utils/pivot/date/getValidEndDate'
import getPeriodRange from 'utils/pivot/date/getPeriodRange'
import isBTMPlan from 'utils/pivot/plan/isBTMPlan'
import getExtendDuration from 'utils/pivot/plan/getExtendDuration'
import { propAccessor, stringToDate } from '@hc-frontend/utils'
import storage from 'proxy-storage'
import { findApplicant } from '@hc-frontend/business'
import { preventOnCloseEvent } from 'core/services/onClose'
import handleSaveQuoteMultiCarrier from './handleSaveQuoteMultiCarrier'

const makeSingleCarrierEmailState = () => ({
  isMultiCarrierEmail: false,
  multiCarrierEmailPlanIds: []
})

function handleSaveQuote() {
  if (this.getAttribute('data-multi-carrier') === 'true') {
    return handleSaveQuoteMultiCarrier.call(this)
  }

  const id = this.getAttribute('id')
  preventOnCloseEvent()

  if (!id) {
    store.update(makeSingleCarrierEmailState())
    return
  }

  const instantQuotePlan = +id.split('-').pop()
  const period = +this.getAttribute('data-period')
  const recurrence = +this.getAttribute('data-recurrence')

  const state = store.getState()
  const hcStorage = state.hcStorage

  const dentalPlanId = propAccessor(state, 'dentalAddons', [])[instantQuotePlan]
  const latitudeId = propAccessor(state, 'latitudeAddons', [])[instantQuotePlan]
  const visionPlanId = propAccessor(state, 'visionAddons', [])[instantQuotePlan]
  const filters = { ...state.filters, period, policies: recurrence }

  const applicant = findApplicant(state.hcStorage.members)
  const plan = state.plans[instantQuotePlan]
  const isBTM = isBTMPlan(plan)
  const sDate = stringToDate(state.sDate)
  const policies = filters.policies
  const isExtendedPlan = isBTM ? false : policies > 1

  const planName = plan.planName
  const dentalVisionTitle = [
    (state.plans[dentalPlanId] || {}).planName,
    (state.plans[visionPlanId] || {}).planName
  ]
    .filter(Boolean)
    .join(' + ')

  const endDate = getValidEndDate({
    startDate: sDate,
    endDate: '',
    period,
    isExtendedPlan,
    isBTM,
    policies: recurrence,
    dob: applicant.dob
  })

  const periodRange = getPeriodRange({
    extendedDuration: getExtendDuration(plan, period),
    period,
    sDate,
    endDate,
    policies
  })

  const addOns = [dentalPlanId, visionPlanId, latitudeId].filter(Boolean)

  store.update({
    ...makeSingleCarrierEmailState(),
    addOns,
    instantQuotePlan,
    planId: instantQuotePlan,
    period,
    recurrence,
    filters,
    dentalPlanId,
    latitudeId,
    visionPlanId,
    periodRange,
    dentalVisionTitle,
    planName
  })

  hcStorage.addOn = addOns.map(v => +v)
  storage.setItem('hc', hcStorage)

  $('#emailQuoteSingular').modal('show')
}

export default handleSaveQuote
